import type { Recipe } from '@/service/recipe/types';

function objects<T>(value: unknown): T[] {
  return Array.isArray(value)
    ? value.filter((item): item is T => !!item && typeof item === 'object')
    : [];
}

// Reads a stored recipe as the app expects it. Firestore documents are not
// parsed: recipes saved before steps existed (April 2023) have none, and a
// list can hold empty entries. The document id always wins over a stored
// id field, so links and updates reach the document that was read.
export function readRecipe(id: string, data: Record<string, unknown>): Recipe {
  return {
    ...(data as Partial<Recipe>),
    id,
    steps: objects<Recipe['steps'][number]>(data.steps),
    ingredients: objects<Recipe['ingredients'][number]>(data.ingredients),
    tags: Array.isArray(data.tags)
      ? data.tags.filter((tag): tag is string => typeof tag === 'string')
      : [],
  } as Recipe;
}
